<template>
  <div>
    <div style="position: relative">
      <div class="businessCooperation">
      </div>
      <div class="hezuodingwei">
        <div class="hezuo">
          <div class="text">
            合作优势
          </div>
          <div class="border_"></div>
        </div>
        <div class="biaoti">
          岳泰兴医疗一直致力于推动医疗行业的数字化转型和创新发展，以打造更加普惠、高效、优质的医疗服务为使命
          <div class="border2_"></div>
        </div>
        <div class="info_list">
          <div class="info_left">
            我们期待与各界企业携手共进，共同探索和开拓医疗市场的无
            限可能性。通过强大的供应链、客户服务和技术支持等方面的赋能，我们将为合作伙伴提供更多的商业价值和社会价值，并共同实现双方的共赢发展。让我们携手并肩，共同推动医疗行业的变革和进步，为人类健康事业贡献更大的力量。
          </div>
          <div class="image_list">
            <div class="image_top">
              <div class="image_info">
                <div class="image">
                  <img src="/status/huojian.png">
                </div>
                <div class="wenzi">高效服务</div>
              </div>
              <div class="image_info">
                <div class="image">
                  <img src="/status/zhongjian.png">
                </div>
                <div class="wenzi">数字化转型</div>
              </div>
              <div class="image_info">
                <div class="image">
                  <img src="/status/qian.png">
                </div>
                <div class="wenzi">惠普医疗</div>
              </div>
            </div>
            <div class="image_bottom">
              <div class="image_info">
                <div class="image">
                  <img src="/status/shou.png">
                </div>
                <div class="wenzi">共赢发展</div>
              </div>
              <div class="image_info">
                <div class="image">
                  <img src="/status/quan.png">
                </div>
                <div class="wenzi">供应链赋能</div>
              </div>
              <div class="image_info">
                <div class="image">
                  <img src="/status/dengpao.png">
                </div>
                <div class="wenzi">创新发展</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hezuoshenqing" ref="slide">
<!--      <div class="hz_info">-->
<!--        <div class="hezuo">-->
<!--          <div class="text">-->
<!--            合作申请-->
<!--          </div>-->
<!--          <div class="border_"></div>-->
<!--        </div>-->
<!--        <div class="form">-->
<!--          <div class="form_name">公司名称<span style="color: rgb(180,14,14)">*</span></div>-->
<!--          <el-input v-model="name" placeholder="请输入公司名称"></el-input>-->
<!--          <div class="form_name">联系人<span style="color: rgb(180,14,14)">*</span></div>-->
<!--          <el-input v-model="nickName" placeholder="请输入联系人"></el-input>-->
<!--          <div class="form_name">手机号<span style="color: rgb(180,14,14)">*</span></div>-->
<!--          <el-input v-model="phone" placeholder="请输入手机号"></el-input>-->
<!--          <div class="form_name">验证码<span style="color: rgb(180,14,14)">*</span></div>-->
<!--          <div class="input_info">-->
<!--            <el-input style="width: 500px;margin-right: 30px" v-model="yzm" placeholder="请输入验证码"></el-input><el-button>获取验证码</el-button>-->
<!--          </div>-->
<!--          <div class="form_name">合作需求<span style="color: rgb(180,14,14)">*</span></div>-->
<!--          <el-input-->
<!--              type="textarea"-->
<!--              :autosize="{ minRows: 4, maxRows: 10}"-->
<!--              placeholder="请输入合作需求"-->
<!--              v-model="textarea">-->
<!--          </el-input>-->
<!--          <div class="submit">提交申请</div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="dibu">
        <div class="dibu_left">
          <div class="text">
            免费获取解决方案
          </div>
          <div class="border_"></div>
          <div class="title">
            预约销售顾问，与您面对面沟通
          </div>
          <div class="image">
            <img src="/status/lianxiwomen.png">
          </div>
          <div class="zxlx">在线联系</div>
        </div>
        <div class="dibu_right">
          <div class="text">
            业务合作
          </div>
          <div class="border_"></div>
          <div class="image">
            <img src="/status/lianxiwomen.png">
          </div>
        </div>
      </div>
    </div>
    <tail_menu></tail_menu>
  </div>
</template>

<script>
import tail_menu from "@/components/tail_menu";
import {enterpriseList} from "@/views/mock";
export default {
  name: "businessCooperation",
  components:{
    tail_menu,
  },
  data(){
    return{
      name:'',
      nickName:'',
      phone:'',
      yzm:'',
      textarea:'',
      slide:false
    }
  },
  mounted(){
    if(this.$route.query.slide){
      this.$refs.slide.scrollIntoView({ behavior: 'smooth' });
      console.log('执行了')
    }
  }
}
</script>

<style scoped lang="scss">
.hezuodingwei{
  position: absolute;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 50px 0;
  .hezuo{
    display: flex;
    align-items: center;
    flex-direction: column;
    .text{
      font-size: 24px;
      font-weight: 600;
      color: #4a7bac;
    }
    .border_{
      margin-top: 10px;
      width: 50px;
      border: 1px solid #327ecb;
    }
  }
  .biaoti{
    margin-top: 50px;
    color: #4a7bac;
    font-size: 24px;

  }
  .border2_{
    margin-top: 40px;
    width: 100px;
    border: 1px solid #327ecb;
  }
  .info_list{
    margin-top: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1150px;
    .info_left{
      width: 500px;
      line-height: 50px;
      font-size: 18px;
    }
  }
  .image_list{
    .image_top,.image_bottom{
      display: flex;
      background: linear-gradient(to bottom, #bed9f6,#ffffff);
      padding: 26px 20px;
      border-radius: 8px;
      box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
      margin-bottom: 30px;
      font-weight: bold;
      font-size: 17px;
      .image_info{
        display: flex;
        padding: 10px 20px;
        border-right: 1.4px solid rgb(187,187,187);
        .image{
          img{
            width: 30px;
            margin-right: 20px;
          }
        }
        .wenzi{
          margin-top: 4px;
        }

      }
      .image_info:last-child{
        border: none;
      }
    }
  }
}

.businessCooperation{
  background: url("/status/hezuoyoushi.png");
  background-repeat: no-repeat;
  background-color: transparent;
  opacity: 0.16;
  background-size: 100%;
  height: 700px;

}
.hezuoshenqing{
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 50px 0;
  background: rgb(222,237,248);
  .hz_info{
    background: white;
    border-radius: 8px;
    padding: 30px;
    width: 900px;
    border: 1px solid rgb(219,227,233);
    .hezuo{
      display: flex;
      align-items: center;
      flex-direction: column;
      .text{
        font-size: 24px;
        font-weight: 600;
        color: #4a7bac;
      }
      .border_{
        margin-top: 10px;
        width: 50px;
        border: 1px solid #327ecb;
      }
    }

    .form{

      .form_name{
        margin-top: 20px;
        margin-bottom: 10px;
        color: #4a7bac;
        font-size: 15px;
      }
      .input_info{
        display: flex;

      }
      .submit{
        background: rgb(122,179,239);
        color: white;
        border-radius: 8px;
        text-align: center;
        width: 400px;
        margin: 40px auto 10px auto;
        padding: 12px 20px;
        cursor: pointer;
      }
    }
  }
}
.dibu{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
  background: rgb(222,237,248);
  .dibu_left{
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 8px;
    background: white;
    padding: 30px;
    width: 270px;
    height: 340px;
    .text{
      font-size: 22px;
      font-weight: bold;
      color: #003b76;
    }
    .border_{
      margin-top: 10px;
      width: 50px;
      border: 1px solid #327ecb;
    }
    .title{
      margin-top: 10px;
      color: #15191d;
      opacity: 0.73;
      font-size: 12px;
    }
    .image{
      img{
        margin-top: 20px;
        width: 180px;
      }
    }
    .zxlx{
      background: black;
      color: white;
      margin-top: 20px;
      font-size: 14px;
      padding: 10px 30px;
    }
  }
  .dibu_right{
    margin-right: 15px;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 8px;
    background: white;
    padding: 30px;
    width: 270px;
    height: 340px;
    margin-left: 110px;
    .text{
      font-size: 22px;
      font-weight: bold;
      color: #003b76;
    }
    .border_{
      margin-top: 10px;
      width: 50px;
      border: 1px solid #327ecb;
    }
    .image{
      img{
        margin-top: 44px;
        width: 200px;
      }
    }
  }
}
::v-deep .el-input__inner{
  background: #f8fbfe;
  border: 1px solid #e6f0fa;
}
::v-deep .el-textarea__inner{
  background: #f8fbfe;
  border: 1px solid #e6f0fa;
}
</style>
